module.exports = __webpack_public_path__ + "img/expense.2c3f7d08.svg";